'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const TripViewModel=require('../../../../dist-es6/client/viewModels/tripViewModel');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;let

ScenarioController=(_class=class ScenarioController extends BaseController{
static get $inject(){
return['$state','$timeout','breadcrumbsService','waypointViewModelService','uncaughtErrorHandler','uiCommandFactory','tripPlanningService'];
}

constructor($state,$timeout,breadcrumbsService,waypointViewModelService,uncaughtErrorHandler,uiCommandFactory,tripPlanningService){
super(uncaughtErrorHandler);

this._isInitialized=!1;
this._$timeout=$timeout;

let{
personInfo,
originalInputs,
fatigueThreshold,
schedule,
route,
queryInterval}=
$state.params;

if(!_.allExist(personInfo,originalInputs,fatigueThreshold,schedule,route,queryInterval)){
$state.go("fdc.features.dashboard");
return;
}

this._$state=$state;
this._waypointViewModelService=waypointViewModelService;
this._tripPlanningService=tripPlanningService;
this._personInfo=personInfo;
this._fatigueThreshold=fatigueThreshold;
this._originalInputs=originalInputs;

this._displayName=this._personInfo.firstName.concat(' ').concat(this._personInfo.lastName);

this._reload({
queryInterval:queryInterval,
route:route,
schedule:schedule});


this._recalculationErrors=[];
this._recalculateTripCommand=uiCommandFactory.make(this._recalculateTrip.bind(this));

breadcrumbsService.dropCrumb('Scenario');

$timeout(()=>{
this._isInitialized=!0;
});
}


_reload(planningResult){
this._queryInterval=planningResult.queryInterval;
this._route=planningResult.route;
this._schedule=planningResult.schedule;


for(let stop of this._route.stops){
if(!_.exists(stop.location.city)&&stop.location.state==='NJ'&&stop.location.street==='27 Chestertown Road'){
stop.location.city='Sicklerville';
}
}

this._waypointsForDisplay=this._waypointViewModelService.createWaypointViewModelsForRoute(this._route.stops,this._route.statusTransitions,wp=>{
this._$timeout(()=>{
this._currentlyEditedWaypoint=wp;
});
});

let firstStop=_.first(this._route.stops);
let lastStop=_.last(this._route.stops);
this._overallTrip=new TripViewModel({
start:firstStop.duration.start,
end:lastStop.duration.end,
origin:firstStop.location,
destination:lastStop.location});

}

get isInitialized(){
return this._isInitialized;
}

get displayName(){
return this._displayName;
}

get fatigueThreshold(){
return this._fatigueThreshold;
}

get waypointsForDisplay(){
return this._waypointsForDisplay;
}

get schedule(){
return this._schedule;
}

get queryInterval(){
return this._queryInterval;
}

get route(){
return this._route;
}

get overallTrip(){
return this._overallTrip;
}

get recalculateTripCommand(){
return this._recalculateTripCommand;
}

get currentlyEditedWaypoint(){
return this._currentlyEditedWaypoint;
}

get recalculationErrors(){
return this._recalculationErrors;
}

cancelEdits(){
if(this._recalculating){
return;
}

if(_.exists(this._currentlyEditedWaypoint)){
this._currentlyEditedWaypoint.edits=null;
}
this._currentlyEditedWaypoint=null;
this._recalculationErrors=[];
}


async _recalculateTrip(){
this._recalculating=!0;
this._recalculationErrors=[];


let inputsForRecalculation=this._originalInputs.map(i=>_.clone(i));
let firstWaypoint=_.first(this.waypointsForDisplay);
let lastWaypoint=_.last(this.waypointsForDisplay);

let inputToUpdate;
let editSource;
switch(this._currentlyEditedWaypoint){
case firstWaypoint:
inputToUpdate=_.first(inputsForRecalculation);
editSource=firstWaypoint;
break;

case lastWaypoint:
inputToUpdate=_.last(inputsForRecalculation);
editSource=lastWaypoint;
break;

default:
console.log('unexpected waypoint edit');
return;}

inputToUpdate.address=editSource.edits.address;
inputToUpdate.displayTime=editSource.edits.displayTime;

let planningResult=await this._tripPlanningService.plan(this._personInfo.id,inputsForRecalculation);

this._recalculating=!1;

if(_.exists(planningResult.errors)){
this._recalculationErrors=planningResult.errors;
return;
}

this._currentlyEditedWaypoint=null;

this._$state.go('fdc.features.scenario',{
personInfo:this._$state.params.personInfo,
fatigueThreshold:this._$state.params.fatigueThreshold,
originalInputs:inputsForRecalculation,
schedule:planningResult.schedule,
route:planningResult.route,
queryInterval:planningResult.queryInterval});

}},(_applyDecoratedDescriptor(_class.prototype,'_recalculateTrip',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_recalculateTrip'),_class.prototype)),_class);


module.exports=ScenarioController;
//# sourceMappingURL=scenarioController.js.map
